import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _archive = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _audio = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _bulkItemUpdateResult = { item: '_enterpriseMediaItem' };
var _bulkUpdateItemRequest = { updateItemRequests: '_updateItemRequest' };
var _bulkUpdateItemResponse = { results: '_bulkItemUpdateResult' };
var _document = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _enterpriseMediaItem = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    assets: '_itemAssets',
};
var _generateFileUploadUrlRequest = {};
var _generateFileUploadUrlResponse = {};
var _getItemRequest = {};
var _getItemResponse = { item: '_enterpriseMediaItem' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _importFileRequest = {};
var _importFileResponse = { item: '_enterpriseMediaItem' };
var _itemAssets = {
    image: '_image',
    video: '_videoV2',
    vector: '_image',
    audio: '_audio',
    document: '_document',
    archive: '_archive',
    model3d: '_model3D',
};
var _itemUploadCallbackRequest = {};
var _itemUploadCallbackResponse = {};
var _linkItemToCategoriesRequest = {};
var _linkItemToCategoriesResponse = {};
var _model3D = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    thumbnail: '_image',
};
var _overwriteItemCategoriesRequest = {};
var _overwriteItemCategoriesResponse = {};
var _queryItemsRequest = {};
var _queryItemsResponse = { items: '_enterpriseMediaItem' };
var _searchItemsRequest = {};
var _searchItemsResponse = { items: '_enterpriseMediaItem' };
var _unlinkItemFromCategoriesRequest = {};
var _unlinkItemFromCategoriesResponse = {};
var _updateItemRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    item: '_enterpriseMediaItem',
};
var _updateItemResponse = { item: '_enterpriseMediaItem' };
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
function resolveComWixMediaEnterprisePublicMediaV1EnterpriseItemsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/enterprise-public-media-server',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/enterprise-public-media-server',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/enterprise-public-media-server',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/enterprise-public-media-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Internal API called by the public media backend, notify about a file that was created enterprise public media server */
export function itemUploadCallback(payload) {
    var _a = serializer(_itemUploadCallbackRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_itemUploadCallbackResponse, {}).fromJSON;
    function __itemUploadCallback(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_item',
            method: 'POST',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.ItemUploadCallback',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseItemsServiceUrl({
                protoPath: '/v1/enterprise/items/upload/callback',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __itemUploadCallback.fromReq = fromReq;
    __itemUploadCallback.__isAmbassador = true;
    return __itemUploadCallback;
}
/** Generate an upload url that will make public media to call the enterprise callback endpoint */
export function generateFileUploadUrl(payload) {
    var _a = serializer(_generateFileUploadUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_generateFileUploadUrlResponse, {}).fromJSON;
    function __generateFileUploadUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_item',
            method: 'POST',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.GenerateFileUploadUrl',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseItemsServiceUrl({
                protoPath: '/v1/enterprise/items/upload/generate-url',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __generateFileUploadUrl.fromReq = fromReq;
    __generateFileUploadUrl.__isAmbassador = true;
    return __generateFileUploadUrl;
}
/** Import a file using a url */
export function importFile(payload) {
    var _a = serializer(_importFileRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_importFileResponse, {
        _archive: _archive,
        _audio: _audio,
        _document: _document,
        _enterpriseMediaItem: _enterpriseMediaItem,
        _image: _image,
        _itemAssets: _itemAssets,
        _model3D: _model3D,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __importFile(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_item',
            method: 'POST',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.ImportFile',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseItemsServiceUrl({
                protoPath: '/v1/enterprise/items/upload/import',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __importFile.fromReq = fromReq;
    __importFile.__isAmbassador = true;
    return __importFile;
}
/**
 * Search items, all filters only support equality
 * Each query must contain a categoryId filter
 */
export function searchItems(payload) {
    var _a = serializer(_searchItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchItemsResponse, {
        _archive: _archive,
        _audio: _audio,
        _document: _document,
        _enterpriseMediaItem: _enterpriseMediaItem,
        _image: _image,
        _itemAssets: _itemAssets,
        _model3D: _model3D,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __searchItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_item',
            method: 'POST',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.SearchItems',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseItemsServiceUrl({
                protoPath: '/v1/enterprise/items/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchItems.fromReq = fromReq;
    __searchItems.__isAmbassador = true;
    return __searchItems;
}
/**
 * Query items allowing to sort by specified fields, all filters only support equality
 * Each query must contain a categoryId filter
 */
export function queryItems(payload) {
    var _a = serializer(_queryItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryItemsResponse, {
        _archive: _archive,
        _audio: _audio,
        _document: _document,
        _enterpriseMediaItem: _enterpriseMediaItem,
        _image: _image,
        _itemAssets: _itemAssets,
        _model3D: _model3D,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __queryItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_item',
            method: 'POST',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.QueryItems',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseItemsServiceUrl({
                protoPath: '/v1/enterprise/items/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryItems.fromReq = fromReq;
    __queryItems.__isAmbassador = true;
    return __queryItems;
}
/** Update an item */
export function updateItem(payload) {
    var _a = serializer(_updateItemRequest, {
        _archive: _archive,
        _audio: _audio,
        _document: _document,
        _enterpriseMediaItem: _enterpriseMediaItem,
        _image: _image,
        _itemAssets: _itemAssets,
        _model3D: _model3D,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateItemResponse, {
        _archive: _archive,
        _audio: _audio,
        _document: _document,
        _enterpriseMediaItem: _enterpriseMediaItem,
        _image: _image,
        _itemAssets: _itemAssets,
        _model3D: _model3D,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updateItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_item',
            method: 'PATCH',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.UpdateItem',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseItemsServiceUrl({
                protoPath: '/v1/enterprise/items/{item.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateItem.fromReq = fromReq;
    __updateItem.__isAmbassador = true;
    return __updateItem;
}
/** Bulk update an item */
export function bulkUpdateItem(payload) {
    var _a = serializer(_bulkUpdateItemRequest, {
        _archive: _archive,
        _audio: _audio,
        _document: _document,
        _enterpriseMediaItem: _enterpriseMediaItem,
        _image: _image,
        _itemAssets: _itemAssets,
        _model3D: _model3D,
        _updateItemRequest: _updateItemRequest,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateItemResponse, {
        _archive: _archive,
        _audio: _audio,
        _bulkItemUpdateResult: _bulkItemUpdateResult,
        _document: _document,
        _enterpriseMediaItem: _enterpriseMediaItem,
        _image: _image,
        _itemAssets: _itemAssets,
        _model3D: _model3D,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __bulkUpdateItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_item',
            method: 'PATCH',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.BulkUpdateItem',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseItemsServiceUrl({
                protoPath: '/v1/bulk/enterprise/items/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateItem.fromReq = fromReq;
    __bulkUpdateItem.__isAmbassador = true;
    return __bulkUpdateItem;
}
/** Get item details */
export function getItem(payload) {
    var _a = serializer(_getItemRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getItemResponse, {
        _archive: _archive,
        _audio: _audio,
        _document: _document,
        _enterpriseMediaItem: _enterpriseMediaItem,
        _image: _image,
        _itemAssets: _itemAssets,
        _model3D: _model3D,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getItem(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_item',
            method: 'GET',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.GetItem',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseItemsServiceUrl({
                protoPath: '/v1/enterprise/items/{itemId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getItem.fromReq = fromReq;
    __getItem.__isAmbassador = true;
    return __getItem;
}
/** Link the item to multiple categories */
export function linkItemToCategories(payload) {
    var _a = serializer(_linkItemToCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_linkItemToCategoriesResponse, {}).fromJSON;
    function __linkItemToCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_item',
            method: 'POST',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.LinkItemToCategories',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseItemsServiceUrl({
                protoPath: '/v1/enterprise/items/{itemId}/link-categories',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __linkItemToCategories.fromReq = fromReq;
    __linkItemToCategories.__isAmbassador = true;
    return __linkItemToCategories;
}
/** Unlink the item from multiple categories */
export function unlinkItemFromCategories(payload) {
    var _a = serializer(_unlinkItemFromCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unlinkItemFromCategoriesResponse, {}).fromJSON;
    function __unlinkItemFromCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_item',
            method: 'POST',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.UnlinkItemFromCategories',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseItemsServiceUrl({
                protoPath: '/v1/enterprise/items/{itemId}/unlink-categories',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unlinkItemFromCategories.fromReq = fromReq;
    __unlinkItemFromCategories.__isAmbassador = true;
    return __unlinkItemFromCategories;
}
/** Overwrite item categories */
export function overwriteItemCategories(payload) {
    var _a = serializer(_overwriteItemCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_overwriteItemCategoriesResponse, {}).fromJSON;
    function __overwriteItemCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.enterprise_public_media.v1.enterprise_item',
            method: 'POST',
            methodFqn: 'com.wix.media.enterprise_public_media.v1.EnterpriseItemsService.OverwriteItemCategories',
            url: resolveComWixMediaEnterprisePublicMediaV1EnterpriseItemsServiceUrl({
                protoPath: '/v1/enterprise/items/{itemId}/overwrite-categories',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __overwriteItemCategories.fromReq = fromReq;
    __overwriteItemCategories.__isAmbassador = true;
    return __overwriteItemCategories;
}
//# sourceMappingURL=http.impl.js.map